"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayConfigNode = exports.isMultiPartConfigNode = exports.isBaseConfigNode = void 0;
const isBaseConfigNode = (node = {}) => typeof node.path === 'string' && typeof node.type === 'string';
exports.isBaseConfigNode = isBaseConfigNode;
const isMultiPartConfigNode = (node = {}) => !(0, exports.isArrayConfigNode)(node) && Boolean(node.subFields);
exports.isMultiPartConfigNode = isMultiPartConfigNode;
const isArrayConfigNode = (node = {}) => node.type === 'array' &&
    node.subFields &&
    Object.values(node.subFields).every((subField) => (0, exports.isBaseConfigNode)(subField));
exports.isArrayConfigNode = isArrayConfigNode;
//# sourceMappingURL=utils.js.map